import {Button, Form, FormInstance, message, Select} from "antd";
import React, {useEffect, useState} from "react";
import {IItem} from "../../../search/utils/interface";
import server from "../../../../../server";

interface IHandleReporteesProps {
    reportees: any[]
    selectedRecord: IItem | null
    modalForm: FormInstance
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    onContinue: () => void;
    getAllReportees: (record: IItem) => Promise<void>;
}

interface IEligibleReportingManagers {
    id: string,
    employeeCode: string,
    name: {
        firstName: string,
        middleName: string,
        lastName: string,
    },
    officialEmail: string,
    profilePhotoThumbnailId: string
}

const HandleReportees = (props: IHandleReporteesProps) => {
    const [managers, setManagers] = useState<IEligibleReportingManagers[]>([]);

    async function fetchEligibleReportingManagers() {
        const payload = props.reportees.map((reportee) => reportee.id);
        try {
            const reportingManagers = await server.employee.eligibleReportingManagers(payload);
            const eligibleReportingManagers = reportingManagers.filter((item: any) => (item.id != props.selectedRecord?.id))
            setManagers(eligibleReportingManagers);
            console.log("reportingManagers", reportingManagers)
        } catch (e) {
            console.log("Error while fetching eligible reporting managers", e);
        }
    }

    useEffect(() => {
        if (props.reportees?.length > 0) {
            fetchEligibleReportingManagers();
        }
    }, [props.selectedRecord?.id, props.reportees]);

    async function assignSupervisor(record: IItem) {
        try {
            const values = await props.modalForm.validateFields();
            for (const reportee of props.reportees) {
                await server.employee.admin.assignSupervisor(
                    reportee.id,
                    values.reportingId
                );
            }
            await props.getAllReportees(record);
            message.success("Reportees transferred successfully!");
        } catch (e) {
            console.log("Error while assigning supervisor", e);
        }
    }

    const handleCancelButton = () => {
        props.setIsModalOpen(false);
        props.modalForm.resetFields();
    }

    return (
        <div className="deactive-modal-content">
            {props.reportees.length > 0 && (
                <div className="reportees-section">
                    <p><strong>These are the following reportees
                        of <b>{props.selectedRecord?.name?.firstName} {props.selectedRecord?.name?.lastName}</b>:</strong>
                    </p>
                    <ul className="reportees-list">
                        {props.reportees.map((reportee: any, index: number) => (
                            <li key={index} className="reportee-item">
                                <span>{reportee.name.firstName} {reportee.name.lastName}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {props.reportees.length === 0 && (

                <div className="deactivation-note">
                    <p><b>Info:</b> No reportees found to transfer. Click Continue to proceed to the next step.</p>
                </div>
            )}

            {props.reportees.length > 0 && (
                <div className="transfer-manager">
                    <p><strong>Please transfer these reportees to a new manager :</strong></p>
                    <Form form={props.modalForm}>
                        <Form.Item
                            name="reportingId"
                            rules={[{required: true, message: "Please select Reporting Manager"}]}
                        >
                            <Select placeholder="Select Reporting Manager">
                                {managers?.map((manager: IEligibleReportingManagers) => (
                                    <Select.Option
                                        key={manager.id}
                                        value={manager.id}
                                    >
                                        {manager.name.firstName} {manager.name.middleName} {manager.name.lastName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Form>
                </div>
            )}

            <div className={'deactivate-modal-footer'}>
                <Button
                    className={'cancel-deactivate-button'}
                    onClick={handleCancelButton}
                >
                    Cancel
                </Button>
                <Button
                    className={'continue-deactivate-button'}
                    onClick={props.onContinue}
                    disabled={props.reportees.length > 0}
                >
                    Continue
                </Button>
                {
                    props.reportees.length > 0 && <Button
                        className={"ok-deactivate-button"}
                        onClick={() => {
                            if (props.selectedRecord) {
                                assignSupervisor(props.selectedRecord);
                            }
                        }}>
                        Transfer reportees
                    </Button>
                }
            </div>
        </div>
    )
}

export default HandleReportees;